export const challenges = {
    namespaced: true,

    state: {
        challenges: [],
        publicChallenge: null
    },

    getters: {
        challenges(state) {
            return state.challenges;
        },

        publicChallenge(state) {
            return state.publicChallenge;
        }
    },

    mutations: {
        setChallenges(state, challenges) {
            state.challenges = Object.freeze(challenges);
        },

        setPublicChallenge(state, challenge) {
            state.publicChallenge = challenge;
        }
    }
};

export default challenges;
